import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('expenseSubmissionBatches', app)
  return store
}
